(function() {
  if (window.FACompare) return;

  var STORAGE_KEY = 'fa_compare';
  var MAX = 6;
  var MOBILE_MAX = 4;

  function getList() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'); }
    catch(e) { return []; }
  }

  function saveList(list) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      dispatch();
    } catch(e) {}
  }

  function dispatch() {
    document.dispatchEvent(new CustomEvent('fa:compare-updated', {
      detail: { list: getList(), count: getList().length }
    }));
  }

  window.FACompare = {
    add: function(product) {
    var list = getList();
    var max = (window.innerWidth <= 599) ? MOBILE_MAX : MAX;
    if (list.length >= max) return false;
    if (list.find(function(p) { return p.handle === product.handle; })) return false;
    list.push(product);
    saveList(list);
    return true;
    },
    remove: function(handle) {
      saveList(getList().filter(function(p) { return p.handle !== handle; }));
    },
    toggle: function(product) {
      if (this.has(product.handle)) { this.remove(product.handle); return false; }
      return this.add(product);
    },
    has: function(handle) {
      return !!getList().find(function(p) { return p.handle === handle; });
    },
    getAll: function() { return getList(); },
    count: function() { return getList().length; },
    isFull: function() {
    var max = (window.innerWidth <= 599) ? MOBILE_MAX : MAX;
    return getList().length >= max;
    },
    clear: function() { saveList([]); }
  };

  document.addEventListener('DOMContentLoaded', function() { dispatch(); });

window.faCompareShowMore = function() {
  const more = document.querySelector('.fa-cmp-more');
  const btn  = document.querySelector('.fa-cmp-show-more-btn');
  if (!more || !btn) return;
  const isVisible = more.classList.contains('fa-cmp-more--visible');
  more.classList.toggle('fa-cmp-more--visible', !isVisible);
  btn.textContent = isVisible ? 'Show more specifications' : 'Show fewer specifications';
};

window.faCompareSaveProduct = function(btn, handle, title, url, image, price, priceUnit) {
  if (!btn || !handle) return;
  FAWishlist.toggle(handle, {
    handle: handle, title: title, url: url,
    image: image, price: price, price_unit: priceUnit
  });
  const isSaved = FAWishlist.has(handle);
  btn.classList.toggle('is-saved', isSaved);

  const iconWrap = btn.querySelector('.fa-cmp-save-icon-wrap');
  const icon = btn.querySelector('.fa-cmp-save-icon');
  const label = btn.querySelector('.fa-cmp-save-label');

  if (iconWrap) {
    iconWrap.style.animation = 'none';
    iconWrap.offsetHeight;
    iconWrap.style.animation = 'fa-card-heartpop 0.38s cubic-bezier(0.36,0.07,0.19,0.97) forwards';
  }
  if (icon) {
    icon.setAttribute('fill', isSaved ? '#d22129' : 'none');
    icon.setAttribute('stroke', isSaved ? '#d22129' : 'currentColor');
  }
  if (label) label.textContent = isSaved ? 'Wishlisted' : 'Wishlist';
};

})();
